import { render, staticRenderFns } from "./editliteproduct.vue?vue&type=template&id=04af04d5&scoped=true&"
import script from "./editliteproduct.vue?vue&type=script&lang=js&"
export * from "./editliteproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af04d5",
  null
  
)

export default component.exports